import http from "../services/httpService";
import jwtDecode from "jwt-decode";

const authEndpoint = "/auth";

export function login(user) {
  return http.post(authEndpoint + "/login", user);
}

export function loginAdmin(user) {
  return http.post(authEndpoint + "/login-admin", user);
}

export function resetPassword(obj) {
  return http.post(authEndpoint + "/reset-admin-password", obj);
}

export function register(user) {
  if (user._id) {
    const body = { ...user };
    delete body._id;
    return http.put(authEndpoint + "/update/" + user._id, body);
  }
  return http.post(authEndpoint + "/register", user);
}

export function getCurrentUser() {
  try {
    const jwt = localStorage.getItem("token");
    const user = jwtDecode(jwt);
    return user;
  } catch (ex) {
    return null;
  }
}

const currentUser = {
  getCurrentUser,
};

export default currentUser;
